import { GAME_CONFIG } from '../data/gameConfig';

// A continuous performance-clock projection disciplined by the audio device.
// Device estimates can be stale or noisy; they must never teleport the scene.
export class SongClock {
  reset() {
    this.offset = null;
    this.lastNow = null;
    this.hasHardwareStamp = false;
  }

  constructor() { this.reset(); }

  resume(songStart, songTime, now) {
    this.offset = songStart + songTime - now / 1000;
    this.lastNow = now;
  }

  sample(ctx, songStart, now) {
    const stamp = ctx.getOutputTimestamp?.();
    const valid = stamp?.contextTime > 0 && stamp.performanceTime > 0
      && now >= stamp.performanceTime && now - stamp.performanceTime < 250;
    let candidate = null;
    if (valid) {
      candidate = stamp.contextTime - stamp.performanceTime / 1000;
      this.hasHardwareStamp = true;
    } else if (!this.hasHardwareStamp) {
      candidate = ctx.currentTime - now / 1000 - (ctx.outputLatency || ctx.baseLatency || 0);
    }
    if (this.offset === null) this.offset = candidate ?? ctx.currentTime - now / 1000;
    else if (candidate !== null && this.lastNow !== null) {
      const limit = Math.max(0, now - this.lastNow) / 1000 * GAME_CONFIG.rhythm.clockCorrectionRate;
      this.offset += Math.max(-limit, Math.min(limit, candidate - this.offset));
    }
    this.lastNow = now;
    return now / 1000 + this.offset - songStart;
  }
}
